export default __webpack_public_path__ + "static/media/E_05_01_bg.67221fae.mp4";